export const Colors = () => [
  '#673AB7',
  '#3F51B5',
  '#1565C0',
  '#009688',
  '#4CAF50',
  '#2E7D32',
  '#388E3C',
]



// WEBPACK FOOTER //
// ./src/components/Elements/Sidebar/Settings/Colors.js